import {
  setActiveAssistantWF,
  setDataAssistantWF,
  setNewAssistantWF,
  setUpdateAssistantWF,
} from "../../../../store/slices/asistantWFSlice";
import { removeUser } from "../../../../store/slices/userSlice";
import { errorToast } from "../../../methods/toast";
import { $authHost } from "../../http";

// Получение списка форм ассистента
export const getAssistantWFList = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/integrations/assistant-form/list?userId=${id}`
      );

      if (data.code === 200) {
        dispatch(setDataAssistantWF(data.assistantForms));
        localStorage.setItem(
          "dataAssistantWF",
          JSON.stringify(data.assistantForms)
        );
      } else {
        errorToast(
          data.message || "Ошибка при получении списка форм ассистента."
        );
      }
    } catch (error) {
      if (!error.response) {
        errorToast("Ошибка сети. Проверьте подключение к интернету.");
      } else {
        const { status } = error.response;

        if (status === 401) {
          dispatch(removeUser());
        } else if (status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      }

      console.error("Ошибка в getAssistantWFList:", error);
    }
  };
};

// Создание формы ассистента
export const createAssistantForm = (
  dataCreate,
  navigate,
  toastError,
  setLoading
) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/assistant-form`,
        dataCreate
      );

      if (data.code === 200) {
        dispatch(setActiveAssistantWF(data.assistantForm));
        navigate(`/integration/dialog-form/active/${data.assistantForm.id}`);
        dispatch(setNewAssistantWF(null));
        localStorage.setItem(
          "activeAssistantWF",
          JSON.stringify(data.assistantForm)
        );
      } else {
        toastError(data.message || "Ошибка создания формы.");
      }
    } catch (error) {
      if (!error.response) {
        toastError("Ошибка сети. Проверьте подключение к интернету.");
      } else {
        const { status } = error.response;

        if (status === 401) {
          dispatch(removeUser());
          toastError("Ошибка авторизации. Пожалуйста, войдите снова.");
        } else if (status === 500) {
          toastError("Ошибка сервера. Попробуйте позже.");
        }
      }
      console.error("Ошибка createAssistantForm:", error);
    } finally {
      setLoading(false);
    }
  };
};

// Обновление формы ассистента
export const updateAssistantForm = (dataUpdate, setLoading) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.put(
        `/integrations/assistant-form`,
        dataUpdate
      );

      if (data.code === 200) {
        dispatch(setUpdateAssistantWF(false));
        dispatch(setNewAssistantWF(null));
        dispatch(setActiveAssistantWF(data.assistantForm));
        localStorage.setItem(
          "activeAssistantWF",
          JSON.stringify(data.assistantForm)
        );
      } else {
        errorToast("Ошибка обновления формы");
      }
    } catch (error) {
      if (!error.response) {
        errorToast("Ошибка сети. Проверьте подключение.");
      } else if (error.response.status === 401) {
        dispatch(removeUser());
      } else if (error.response.status === 500) {
        errorToast("Ошибка сервера. Попробуйте позже.");
      }
      console.error("updateAssistantForm error:", error);
    } finally {
      setLoading(false);
    }
  };
};

// Обновление статуса
export const updateAssistantFormStatus = (statusData) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/assistant-form/status`,
        statusData
      );

      if (data.code === 200) {
        dispatch(setActiveAssistantWF(data.assistantForm));
        localStorage.setItem(
          "activeAssistantWF",
          JSON.stringify(data.assistantForm)
        );
      } else {
        errorToast("Ошибка обновления статуса формы");
      }
    } catch (error) {
      if (!error.response) {
        errorToast("Ошибка сети. Проверьте подключение.");
      } else if (error.response.status === 401) {
        dispatch(removeUser());
      } else if (error.response.status === 500) {
        errorToast("Ошибка сервера. Попробуйте позже.");
      }
      console.error("error put widget status", error);
    }
  };
};
